$(document).ready(function () {
    $(document).on("click", ".help_box_menu_item", function() {
        let positionToScroll = $($(this).find(".scroll-block").attr("type-id")).offset().top;
        $(window).scrollTop(positionToScroll - 100);
    });

    $(document).on('click','.help_box_content_block_item_title', function(e){
        $(this).nextAll('.help_box_content_block_item_content').slideToggle(150);
        $(this).toggleClass('active');
        $(this).find('.icon-plus, .icon-minus').toggleClass("d-none")
    });
})
